/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { JobEntity } from '../models/job-entity';
import { JobTypeEntity } from '../models/job-type-entity';
import { JobFrequencyEntity } from '../models/job-frequency-entity';
@Injectable({
  providedIn: 'root',
})
class JobSchedulerService extends __BaseService {
  static readonly getApiJobschedulerGetallscheduledjobsasyncPath = '/api/jobscheduler/getallscheduledjobsasync';
  static readonly getApiJobschedulerGetalljobtypesasyncPath = '/api/jobscheduler/getalljobtypesasync';
  static readonly getApiJobschedulerGetalljobfrequenciesasyncPath = '/api/jobscheduler/getalljobfrequenciesasync';
  static readonly getApiJobschedulerGetjobtypebyidasyncPath = '/api/jobscheduler/getjobtypebyidasync';
  static readonly getApiJobschedulerGetjobfrequencybyidasyncPath = '/api/jobscheduler/getjobfrequencybyidasync';
  static readonly getApiJobschedulerGetscheduledjobbyidasyncPath = '/api/jobscheduler/getscheduledjobbyidasync';
  static readonly postApiJobschedulerAddorupdatescheduledjobasyncPath = '/api/jobscheduler/addorupdatescheduledjobasync';
  static readonly getApiJobschedulerDeletescheduledjobasyncPath = '/api/jobscheduler/deletescheduledjobasync';
  static readonly getApiJobschedulerTriggerscheduledjobasyncPath = '/api/jobscheduler/triggerscheduledjobasync';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param api-version The requested API version
   * @return Get All Scheduled Jobs
   */
  getApiJobschedulerGetallscheduledjobsasyncResponse(apiVersion?: string): __Observable<__StrictHttpResponse<JobEntity>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (apiVersion != null) __params = __params.set('api-version', apiVersion.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobscheduler/getallscheduledjobsasync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JobEntity>;
      })
    );
  }
  /**
   * @param api-version The requested API version
   * @return Get All Scheduled Jobs
   */
  getApiJobschedulerGetallscheduledjobsasync(apiVersion?: string): __Observable<JobEntity> {
    return this.getApiJobschedulerGetallscheduledjobsasyncResponse(apiVersion).pipe(
      __map(_r => _r.body as JobEntity)
    );
  }

  /**
   * @param api-version The requested API version
   * @return Get All Job Types
   */
  getApiJobschedulerGetalljobtypesasyncResponse(apiVersion?: string): __Observable<__StrictHttpResponse<JobTypeEntity>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (apiVersion != null) __params = __params.set('api-version', apiVersion.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobscheduler/getalljobtypesasync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JobTypeEntity>;
      })
    );
  }
  /**
   * @param api-version The requested API version
   * @return Get All Job Types
   */
  getApiJobschedulerGetalljobtypesasync(apiVersion?: string): __Observable<JobTypeEntity> {
    return this.getApiJobschedulerGetalljobtypesasyncResponse(apiVersion).pipe(
      __map(_r => _r.body as JobTypeEntity)
    );
  }

  /**
   * @param api-version The requested API version
   * @return Get All Job Frequencies
   */
  getApiJobschedulerGetalljobfrequenciesasyncResponse(apiVersion?: string): __Observable<__StrictHttpResponse<JobFrequencyEntity>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (apiVersion != null) __params = __params.set('api-version', apiVersion.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobscheduler/getalljobfrequenciesasync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JobFrequencyEntity>;
      })
    );
  }
  /**
   * @param api-version The requested API version
   * @return Get All Job Frequencies
   */
  getApiJobschedulerGetalljobfrequenciesasync(apiVersion?: string): __Observable<JobFrequencyEntity> {
    return this.getApiJobschedulerGetalljobfrequenciesasyncResponse(apiVersion).pipe(
      __map(_r => _r.body as JobFrequencyEntity)
    );
  }

  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerGetjobtypebyidasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   *
   * @return Get Job Type By ID
   */
  getApiJobschedulerGetjobtypebyidasyncResponse(params: JobSchedulerService.GetApiJobschedulerGetjobtypebyidasyncParams): __Observable<__StrictHttpResponse<JobTypeEntity>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobscheduler/getjobtypebyidasync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JobTypeEntity>;
      })
    );
  }
  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerGetjobtypebyidasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   *
   * @return Get Job Type By ID
   */
  getApiJobschedulerGetjobtypebyidasync(params: JobSchedulerService.GetApiJobschedulerGetjobtypebyidasyncParams): __Observable<JobTypeEntity> {
    return this.getApiJobschedulerGetjobtypebyidasyncResponse(params).pipe(
      __map(_r => _r.body as JobTypeEntity)
    );
  }

  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerGetjobfrequencybyidasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   *
   * @return Get Job Frequency By ID
   */
  getApiJobschedulerGetjobfrequencybyidasyncResponse(params: JobSchedulerService.GetApiJobschedulerGetjobfrequencybyidasyncParams): __Observable<__StrictHttpResponse<JobFrequencyEntity>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobscheduler/getjobfrequencybyidasync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JobFrequencyEntity>;
      })
    );
  }
  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerGetjobfrequencybyidasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   *
   * @return Get Job Frequency By ID
   */
  getApiJobschedulerGetjobfrequencybyidasync(params: JobSchedulerService.GetApiJobschedulerGetjobfrequencybyidasyncParams): __Observable<JobFrequencyEntity> {
    return this.getApiJobschedulerGetjobfrequencybyidasyncResponse(params).pipe(
      __map(_r => _r.body as JobFrequencyEntity)
    );
  }

  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerGetscheduledjobbyidasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   *
   * @return Get Scheduled Job By ID
   */
  getApiJobschedulerGetscheduledjobbyidasyncResponse(params: JobSchedulerService.GetApiJobschedulerGetscheduledjobbyidasyncParams): __Observable<__StrictHttpResponse<JobEntity>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobscheduler/getscheduledjobbyidasync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JobEntity>;
      })
    );
  }
  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerGetscheduledjobbyidasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   *
   * @return Get Scheduled Job By ID
   */
  getApiJobschedulerGetscheduledjobbyidasync(params: JobSchedulerService.GetApiJobschedulerGetscheduledjobbyidasyncParams): __Observable<JobEntity> {
    return this.getApiJobschedulerGetscheduledjobbyidasyncResponse(params).pipe(
      __map(_r => _r.body as JobEntity)
    );
  }

  /**
   * @param params The `JobSchedulerService.PostApiJobschedulerAddorupdatescheduledjobasyncParams` containing the following parameters:
   *
   * - `body`:
   *
   * - `api-version`: The requested API version
   */
  postApiJobschedulerAddorupdatescheduledjobasyncResponse(params: JobSchedulerService.PostApiJobschedulerAddorupdatescheduledjobasyncParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.body;
    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/jobscheduler/addorupdatescheduledjobasync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `JobSchedulerService.PostApiJobschedulerAddorupdatescheduledjobasyncParams` containing the following parameters:
   *
   * - `body`:
   *
   * - `api-version`: The requested API version
   */
  postApiJobschedulerAddorupdatescheduledjobasync(params: JobSchedulerService.PostApiJobschedulerAddorupdatescheduledjobasyncParams): __Observable<null> {
    return this.postApiJobschedulerAddorupdatescheduledjobasyncResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerDeletescheduledjobasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   */
  getApiJobschedulerDeletescheduledjobasyncResponse(params: JobSchedulerService.GetApiJobschedulerDeletescheduledjobasyncParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobscheduler/deletescheduledjobasync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerDeletescheduledjobasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   */
  getApiJobschedulerDeletescheduledjobasync(params: JobSchedulerService.GetApiJobschedulerDeletescheduledjobasyncParams): __Observable<null> {
    return this.getApiJobschedulerDeletescheduledjobasyncResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerTriggerscheduledjobasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   */
  getApiJobschedulerTriggerscheduledjobasyncResponse(params: JobSchedulerService.GetApiJobschedulerTriggerscheduledjobasyncParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.apiVersion != null) __params = __params.set('api-version', params.apiVersion.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobscheduler/triggerscheduledjobasync`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `JobSchedulerService.GetApiJobschedulerTriggerscheduledjobasyncParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `api-version`: The requested API version
   */
  getApiJobschedulerTriggerscheduledjobasync(params: JobSchedulerService.GetApiJobschedulerTriggerscheduledjobasyncParams): __Observable<null> {
    return this.getApiJobschedulerTriggerscheduledjobasyncResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module JobSchedulerService {

  /**
   * Parameters for getApiJobschedulerGetjobtypebyidasync
   */
  export interface GetApiJobschedulerGetjobtypebyidasyncParams {
    id?: number;

    /**
     * The requested API version
     */
    apiVersion?: string;
  }

  /**
   * Parameters for getApiJobschedulerGetjobfrequencybyidasync
   */
  export interface GetApiJobschedulerGetjobfrequencybyidasyncParams {
    id?: number;

    /**
     * The requested API version
     */
    apiVersion?: string;
  }

  /**
   * Parameters for getApiJobschedulerGetscheduledjobbyidasync
   */
  export interface GetApiJobschedulerGetscheduledjobbyidasyncParams {
    id?: number;

    /**
     * The requested API version
     */
    apiVersion?: string;
  }

  /**
   * Parameters for postApiJobschedulerAddorupdatescheduledjobasync
   */
  export interface PostApiJobschedulerAddorupdatescheduledjobasyncParams {
    body?: JobEntity;

    /**
     * The requested API version
     */
    apiVersion?: string;
  }

  /**
   * Parameters for getApiJobschedulerDeletescheduledjobasync
   */
  export interface GetApiJobschedulerDeletescheduledjobasyncParams {
    id?: number;

    /**
     * The requested API version
     */
    apiVersion?: string;
  }

  /**
   * Parameters for getApiJobschedulerTriggerscheduledjobasync
   */
  export interface GetApiJobschedulerTriggerscheduledjobasyncParams {
    id?: number;

    /**
     * The requested API version
     */
    apiVersion?: string;
  }
}

export { JobSchedulerService }
